import type { App } from 'vue';
import router from '@/router';
import routes from './routes';

export declare interface Dashboard {
  install: (app: App) => void;
}

export function createDashboard() : Dashboard {
  return {
    install: (app: App) => {
      routes.forEach(route => {
        router.addRoute('base', route);
      });
    },
  };
}